import React, { useState } from 'react'
import { Typography, Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Stack } from "@mui/material"
import { ReactComponent as LocationIcon } from "../../Icons/location.svg"
import { ReactComponent as FavouritesIcon } from "../../Icons/favouritesIcon.svg"
import { ReactComponent as ShareIcon } from "../../Icons/ShareIcon.svg"
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'


export default function Pricing({ hostelData }) {
    const language = useSelector((state) => state.language.language)
    const {t} = useTranslation()
    console.log(language)
    return (
        <>
            <Box mt={6} mb={4} display="flex" justifyContent='center'>
                <Typography variant="h6_1" color="primary" border="1px solid #27BAC4" padding="10px 50px" borderRadius="50px" letterSpacing="1.1px" width="fit-content">{t("PRICING")}</Typography>
            </Box>
            <Stack rowGap={3}>
                {hostelData?.HostelTypes?.map((item, index) => (
                    <>
                        <Typography variant="h6_1" color='#222222'>{`${hostelData?.title[language]} (${item?.Hostel_type[language]})`}</Typography>
                        <TableContainer sx={{ borderRadius: "0px", mb: 5 }}>
                            <Table sx={{ minWidth: 650, background: "#FAFAFA", border : '1px solid #e5e5e5'}} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="h7_1" color='#333333'>{t("Room Type")}</Typography>
                                        </TableCell>
                                        <TableCell> <Typography variant="h7_1" color='#333333'>{t("6 Months Contract")}</Typography></TableCell>
                                        <TableCell> <Typography variant="h7_1" color='#333333'>{t("12 Months Contract")}</Typography></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {item?.room_type.map((itm, ind) => (
                                        <TableRow key={item.name} sx={{ borderTop: ".5px solid #e5e5e5" }} >
                                            <TableCell ><Typography variant="h7_3" color='#333333'>{itm?.room_type_name[language] || "-"}</Typography></TableCell>
                                            <TableCell ><Typography variant="h7_1" color='#333333'>{`S$ ${itm?.six_month_cont}/${t("month")}`|| "_"}</Typography></TableCell>
                                            <TableCell ><Typography variant="h7_1" color='#333333'>{`S$ ${itm?.twelve_month_cont}/${t("month")}` || "-"}</Typography></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ))}


            </Stack>
        </>
    )
}
